import * as React from 'react';
import {connect} from 'react-redux';

import {reduxForm} from 'redux-form';

import {SidebarFormWrapper} from 'shells/form/sidebar-form-wrapper';

import {
    transformTriggerConditionsToState,
    transformGoalConditionsToState,
    transformNextStepConfigToState,
} from './helpers';

type Props = {
    title: string;
    subtitle?: string;
    onClose: () => any;
    deleteProps?: {
        onDelete: () => Promise<any>;
        buttonText?: string;
        title: string;
        message: string;
    };
    children: React.ReactNode;
    isNewItem: boolean;
    existingStartTrigger: any | null | undefined;
    existingGoal: any | null | undefined;
    existingNextStep: any | null | undefined;
    isSaving: boolean;
    saveFailedErrorMessage: string | null | undefined;
    handleSubmit: (eventOrSubmit?: any) => undefined | Promise<any>;
    invalid: boolean;
    pristine: boolean;
    submitting: boolean;
};

export const FORM_NAME = 'DRIP_SEQUENCE_SIDEBAR_FORM';

function DripSequenceSidebarFormComponentConnected(props: Props) {
    return <SidebarFormWrapper {...props} />;
}

// @ts-expect-error
const mapStateToProps = (_, ownProps: Props) => {
    const startTrigger = ownProps.existingStartTrigger;
    const goal = ownProps.existingGoal;
    const nextStep = ownProps.existingNextStep;
    let initialValues;

    if (startTrigger) {
        initialValues = {
            triggerType: startTrigger.type,
            ...transformTriggerConditionsToState(startTrigger),
        };
    }

    if (goal) {
        initialValues = {
            goalType: goal.type,
            ...transformGoalConditionsToState(goal),
        };
    }

    if (nextStep) {
        initialValues = {
            nextStepType: nextStep.type,
            ...transformNextStepConfigToState(nextStep),
        };
    }

    return {
        initialValues: initialValues,
    };
};

export const DripSequenceSidebarFormComponent = reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true,
    enableReinitialize: true,
    // @ts-expect-error
})(DripSequenceSidebarFormComponentConnected);

// const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
const connector = connect(mapStateToProps);

export const DripSequenceSidebarForm = connector(DripSequenceSidebarFormComponent);
